import React from 'react'
import { setConfig } from 'react-hot-loader'
import 'styles/main.scss'
import { graphql } from 'gatsby'
import ContentBlock from 'components/ContentBlock'
import SuccessStories from 'components/SuccessStories'
import GetStarted from 'components/GetStarted'
import SearchByBlock from 'components/SearchByBlock'
import Modal from 'components/Modal'
import ModalProvider from 'providers/Modal'
import Layout from 'components/layouts/home'
import HomeBanner from 'components/HomeBanner'
import Panel from 'components/common/Panel'
import Register from 'components/Register'
import Login from 'components/Login'
// import { InView } from 'react-intersection-observer'
// import Loadable from 'react-loadable'

setConfig({ pureSFC: true })

// const BelowFold = ({ inView, ref }) => {
//   const SuccessStories = Loadable({
//     loader: () => import('../components/SuccessStories'),
//     loading() {
//       return <div>Loading...</div>
//     },
//   })
//   return <div ref={ref}>{inView && <SuccessStories />}</div>
// }

const Panels = props => (
  <>
    <Panel id="login" isActive="login">
      <Login />
    </Panel>
    <Panel id="register" isActive="register">
      <Register {...props} />
    </Panel>
  </>
)

const prepareStoriesCriteria = props => ({
  storiesType: props.matrimonial_type,
  storiesDb:
    props.matrimonial_type === 'caste'
      ? { religion: props.matrimonialDb, caste: props.matrimonialDb }
      : props.matrimonialDb,
})

const IndexPage = props => {
  return (
    <Layout {...props}>
      <ModalProvider>
        <HomeBanner {...props} />
        <ContentBlock />
        <SuccessStories
          storiesTitle={props.data.airtable.data.success_story_heading}
          storiesCriteria={prepareStoriesCriteria(props.data.airtable.data)}
        />
        <GetStarted />
        <SearchByBlock
          searchByData={props.data.airtable.data.SearchByDomainLinks}
        />
        <Modal>
          <Panels {...props} />
        </Modal>
      </ModalProvider>
    </Layout>
  )
}

export const query = graphql`
  query homePageData($domain: String!) {
    airtable(table: { eq: "Homepages" }, data: { filename: { eq: $domain } }) {
      data {
        title
        metatags
        description
        leading_copy_line1
        success_story_heading
        matrimonialDb
        matrimonial_type
        SearchByDomainLinks {
          data {
            id
            anchortag
            link
            type
            subtype
            orderby
          }
        }
        footer_text
      }
      fields {
        webCreatives
        mobileCreatives
        metaImage
        domainLogo
        logoDimension
        showSixMillion
        androidAppStore
        iphoneAppStore
        domainReligion
        domainLanguage
        domainCountry
        topNavRightColor
      }
    }
  }
`
export default IndexPage
